
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:924)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#28A920"}})]),_c('path',{attrs:{"d":"M32.375 26.103a8 8 0 00-11.345-10.05l-.992-1.737A9.996 9.996 0 0130 14.34c4.49 2.592 6.21 8.142 4.117 12.77l1.342.774-4.165 2.214-.165-4.714 1.246.719zm-14.75-6.206a8.001 8.001 0 0011.345 10.05l.992 1.737A9.996 9.996 0 0120 31.66c-4.49-2.592-6.21-8.142-4.117-12.77l-1.343-.773 4.165-2.214.165 4.714-1.246-.719.001-.001zM21.5 25H27a.5.5 0 000-1h-4a2.5 2.5 0 010-5h1v-1h2v1h2.5v2H23a.5.5 0 000 1h4a2.5 2.5 0 110 5h-1v1h-2v-1h-2.5v-2z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:924","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:924"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:924","result":"shape"}})])])])
          )
        }
      }
    